import CONSTANTS from "../../util/constants";

const initState = {
  isLoading: false,
  id: "",
  divisionName: "",
  getDivisionData: [],
  addDivisionData: [],
  editDivisionData: [],
  getDivisionDataById: [],
  divisionSelected: {},
};

const DivisionReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.DIVISION_NAME_UPDATE:
      return {
        ...state,
        divisionName: payload.value,
      };

    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_API_SUCCESS:
      return {
        ...state,
        addDivisionData: payload.value,
      };

    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_API_SUCCESS:
      return {
        ...state,
        getDivisionData: payload.value,
      };

    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_API_SUCCESS:
      return {
        ...state,
        editDivisionData: payload.value,
      };

    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
      .GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS:
      return {
        ...state,
        getDivisionDataById: payload.value,
      };
    case CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.DIVISION_SELECTED:
      return {
        ...state,
        divisionSelected: payload.value,
      };
    default:
      return state;
  }
};

export default DivisionReducer;
